<template>
  <div id="app">
    <router-view v-if="errorRequest == null"></router-view>
    <error-page v-else
                type="loading-error"
                hint="加载失败"
    >
      <ym-button class="retry-btn"
                 plain
                 type="primary"
                 size="small"
                 @click="handleLoadingError"
      >
        点击重试
      </ym-button>
    </error-page>
  </div>
</template>

<script>
  import ErrorPage from '@/components/ErrorPage';
  import {
    parseQuery,
    setShareFrom,
    setOriginFrom,
    getAlertMessage,
  } from '@/utils';
  import { MessageBox, Button } from 'element-ui';
  import { mapGetters } from 'vuex';
  import request from '@/utils/request';

  export default {
    name: 'App',
    metaInfo: {
      title: '少年商学院',
    },
    components: {
      ErrorPage,
      'ym-button': Button,
    },
    computed: {
      ...mapGetters([
        'errorRequest',
        'showErrorPage',
      ]),
    },
    methods: {
      setPageFromParams() {
        // 记录页面来源
        const { search } = window.location;
        if (search !== '') {
          const query = parseQuery(search) || {};
          const { ymsf, origin } = query;
          if (ymsf) {
            setShareFrom(ymsf);
          }
          if (origin) {
            setOriginFrom(origin);
          }
        }
      },
      showLocationAlertMessage() {
        const message = getAlertMessage();
        if (message && message !== '') {
          MessageBox.alert(message, '', {
            confirmButtonText: '知道了',
          });
        }
      },
      handleLoadingError() {
        const { errorRequest } = this;
        if (errorRequest == null) return;
        request(errorRequest);
      },
    },
    created() {
      this.setPageFromParams();
      this.showLocationAlertMessage();
    },
  };
</script>

<style lang="less">
  @import '~@/assets/styles/index.less';

  #app {
    height: 100%;
    font-size: @font-size-base;
  }

  .retry-btn {
    margin-top: @size-medium;
    border-radius: 35px;
  }
</style>
